import {
    UserStatusCircleProgressGlowingBackgroundStyled
} from './styled/UserStatusCircleProgressGlowingBackgroundStyled';
import classNames from 'classnames';

interface IUserStatusCircleProgressGlowingBackgroundProps {
    animationType?: string;
    animationDurationMs?: number;
    color: string;
    isShow?: boolean;
    size?: number;
}

function UserStatusCircleProgressGlowingBackground(props: IUserStatusCircleProgressGlowingBackgroundProps) {
    const { animationDurationMs, animationType, color, isShow, size } = props;

    return <UserStatusCircleProgressGlowingBackgroundStyled
        animationDurationMs={animationDurationMs}
        animationType={animationType}
        size={size}
        className={classNames({ hidden: !isShow })}
    >
        <svg width="100%" height="100%" viewBox="0 0 154 154" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_19257_106602)">
                <circle cx="77" cy="77" r="24" fill={color}/>
            </g>
            <defs>
                <filter id="filter0_f_19257_106602" x="0.299999" y="0.299999" width="153.4" height="153.4"
                        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="26.35" result="effect1_foregroundBlur_19257_106602"/>
                </filter>
            </defs>
        </svg>
    </UserStatusCircleProgressGlowingBackgroundStyled>
}

export default UserStatusCircleProgressGlowingBackground;
